enum enumStorageType {
  local,
  session,
  Cookie,
}
enum enumPermissions {
  UserManagement = '38c18f4d-67ec-4e83-9add-0f7a92e88e34',
  RoleManagement = '52981628-1e76-4239-b99c-cc5e9db73733',
  BaseInfoManagement = '7a7910ff-e3cb-4c9f-ada7-0cf88b2041f7',
  EventManagement = 'e7d6ed1c-6c22-4b03-81b4-b7d3dbea3bd6',
}
enum MuiMessageBarType {
  /** Info styled MessageBar */
  info = 'info',
  /** Error styled MessageBar */
  error = 'error',
  /** Blocked styled MessageBar */

  success = 'success',
  /** Warning styled MessageBar */
  warning = 'warning',
}

enum enumFormsStatus {
  Draft = 0,
  InProcces = 1,
  DocumentDefects = 2,
  Rejected = 3,
  Accepted = 4,
}

enum enumEventSections {
  DocumentedAndDigitalMedia = 1,
  VisualAndAuditoryMedia = 2,
}
enum enumEventSections_Fa {
  'رسانه های مکتوب و دیجیتال' = 1,
  'رسانه های دیداری و شنیداری' = 2,
}
enum enumArtTemplates {
  News = 1,
  Report = 2,
  Conversation = 3,
  Title = 4,
  Note_Article_Editorial = 5,
}
enum enumArtTemplates_FA {
  'خبر' = 1,
  'گزارش' = 2,
  'گفتگو' = 3,
  'تیتر' = 4,
  'یادداشت، مقاله، سرمقاله' = 5,
}

export {
  enumStorageType,
  MuiMessageBarType,
  enumFormsStatus,
  enumPermissions,
  enumEventSections,
  enumEventSections_Fa,
  enumArtTemplates,
  enumArtTemplates_FA,
};
